import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'AreaMaster',
  //   description: 'description of AreaMaster',
  //   url: '/area-master',
  // },
];

export default help;
